import type { VariantDef } from "../types";

export const variant: VariantDef = {
  appName: "Klereo Connect",
  appId: "com.klereo.connect",
  storeLinks: {
    playStore:
      "https://play.google.com/store/apps/details?id=com.klereo.connect&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
    appStore: "https://apps.apple.com/app/klereo-connect/id6446199571",
  },
  bleNamePrefix: "Klereo",
};
